enum TipoEmissaoNotaAutomatica {
    PadraoMarcado = 1,
    PadraoDesmarcado = 2,
    MarcadoSemEdicao = 3,
}

export default TipoEmissaoNotaAutomatica;
